import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute(
  '/_private/_route/_internal/people/$identityId/accounts/',
)({
  validateSearch: z.object({
    // The login whose settings are shown; the executive login when absent.
    login: z.string().optional().catch(undefined),
    // `person_uuid` picks which login the create-login modal opens for.
    person_uuid: z.string().optional().catch(undefined),
  }),
});
